import { createContext } from "react";

const MultiViewPanelAdministracionContext = createContext();

export default MultiViewPanelAdministracionContext;
